import type { ServerInfoSnapshot } from "@/app/serverInfoController";
import type { ServerInfoBadgeState } from "./ServerInfoBadge";

// 폴링 스냅샷을 배지 상태로 변환한다. 마지막 성공값이 있으면 이후 조회가 실패해도 그 값을
// 표시한다. 배지는 배포 식별자이고 서버 상태 표시가 아니다. 짧은 실패로 UNKNOWN 으로 바뀌면
// 사용자가 잘못 이해할 수 있다.
export function toServerInfoBadgeState(snapshot: ServerInfoSnapshot): ServerInfoBadgeState {
  if (snapshot.data !== null) {
    return {
      status: "ready",
      environment: snapshot.data.environment,
      version: snapshot.data.version,
    };
  }
  return snapshot.failed ? { status: "failed" } : { status: "loading" };
}
